import { useEffect, useState } from "react";
import { subscribeConnectivity } from "@/lib/connectivity";

// Prompt AJ - Cambio 3: franja fija de "sin conexión" para vigiladores en
// obras con poca señal -- aparece y desaparece sola, no requiere que el
// usuario haga nada.
export function OfflineBanner() {
  const [offline, setOffline] = useState(false);
  useEffect(() => subscribeConnectivity(setOffline), []);
  if (!offline) return null;
  return (
    <div data-testid="offline-banner" style={{
      position: "fixed", top: 0, left: 0, right: 0, zIndex: 9999,
      background: "#BF3437", color: "#FFFBF4", textAlign: "center",
      padding: "8px 12px", fontSize: 13, fontWeight: 700, letterSpacing: "0.02em",
    }}>
      Sin conexión — reintentando…
    </div>
  );
}
